import script from "./WapTrainingBriefView.vue?vue&type=script&lang=ts&setup=true"
export * from "./WapTrainingBriefView.vue?vue&type=script&lang=ts&setup=true"

import "./WapTrainingBriefView.vue?vue&type=style&index=0&id=38fc3ef4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38fc3ef4"]])

export default __exports__